import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Row, Col, Button, Spinner } from 'react-bootstrap';
import FalconCloseButton from 'components/common/FalconCloseButton';

const ModalSeguroRecuperarSuscripcion = ({
    show,
    onClose,
    onConfirm,
    processing,
    suscripcionInfo
}) => {
    if (!show) return null;

    return (
        <Modal
            show={show}
            onHide={onClose}
            size="md"
            backdrop="static"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header>
                <Modal.Title>¿Seguro?</Modal.Title>
                <FalconCloseButton className="btn btn-circle btn-sm transition-base p-0" onClick={onClose} />
            </Modal.Header>
            <Modal.Body className="text-dark fs-2">
                <Row className="mb-3">
                    <Col>
                        ¿Estás <strong>seguro</strong> que deseas recuperar esta suscripción?
                        {suscripcionInfo && (
                            <div className="mt-2">
                                 {suscripcionInfo.vNombreSuscripcion} (#{suscripcionInfo.idSuscripcion})
                            </div>
                        )}
                    </Col>
                </Row>
                <Row>
                    <Col className="col-6">
                        {processing ? (
                            <Button variant="secondary" disabled className="col-12 fs--1">
                                <Spinner as="span" animation="grow" size="sm" role="status" className="me-2" aria-hidden="true" />
                                Procesando...
                            </Button>
                        ) : (
                            <Button onClick={onConfirm} variant="primary" className="col-12">SI</Button>
                        )}
                    </Col>
                    <Col className="col-6">
                        {processing ? (
                            <Button variant="secondary" disabled className="col-12 fs--1">
                                <Spinner as="span" animation="grow" size="sm" role="status" className="me-2" aria-hidden="true" />
                                Procesando...
                            </Button>
                        ) : (
                            <Button onClick={onClose} variant="danger" className="col-12">NO</Button>
                        )}
                    </Col>
                </Row>
            </Modal.Body>
            <Modal.Footer></Modal.Footer>
        </Modal>
    );
};

ModalSeguroRecuperarSuscripcion.propTypes = {
    show: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    processing: PropTypes.bool,
    suscripcionInfo: PropTypes.object
};

export default ModalSeguroRecuperarSuscripcion;
